/**
 * PREVIEW PARITY REWORK (2026-07-28 ruling), item #10: mirrors Python's
 * str.title() for the fallback casing paths shared with backend/utils/
 * document_generator.py - e.g. _procurement_type_label's unknown-value
 * fallback (cleaned.title()) and doc_type_labels.get(doc_type,
 * doc_type.title()) for an unrecognized Supporting Document type.
 * Capitalizes the first letter of each run of ASCII letters, lowercases
 * the rest - "unknown_type" -> "Unknown_Type", matching Python exactly
 * (underscores/digits are treated as word separators, same as Python's
 * definition of "cased" characters).
 */
export const pythonTitleCase = (str) =>
  String(str || '').replace(/[A-Za-z]+/g, (word) => word[0].toUpperCase() + word.slice(1).toLowerCase());
